import * as React from 'react';

import {useLoaderData} from 'react-router-dom';
import {useParams} from 'react-router-dom';
import {useNavigate} from 'react-router-dom';
import { useMessage } from '../context/MessageProvider';

import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import Row from '../components/Row';
import FullScreenDrawer from '../components/FullScreenDrawer';

import TimerIcon from '@mui/icons-material/Timer';

import {useForm, FormProvider} from 'react-hook-form';
import { useFormContext } from 'react-hook-form';
import FormButton from '../components/form/FormButton';
import FormTextField from '../components/form/FormTextField';
import ComponentTextField from '../components/form/ComponentTextField';
import FormMultiSelectChipsFilter from '../components/form/FormMultiSelectChipsFilter';

import Header from "../components/Header";

import { findModel } from '../utils/model';

import EwpButton from '../components/EwpButton';

import { listAnimals } from '../models/animals';
import { listBehaviorTagSets } from '../models/behaviorTags';
import { getAssessment } from '../models/assessments';
import { newSectionBBehavior, resetSectionBRecord, getSectionB, saveSectionB, saveSectionBLocal } from '../models/sectionb';


import GoBack from '../components/GoBack';

import {today} from "../utils/datetime";

import Timer from '../components/Timer';

import CustomTooltip from '../components/tooltip/CustomTooltip';
import HelpIcon from '@mui/icons-material/Help';

import { useLayout } from '../components/layout/Layout';
import { useConfirmationDialog } from '../context/ConfirmationDialogContext';
import { useConnectivity } from '../context/ConnectivityProvider';
import { useTimer } from '../context/TimerProvider';
import { useSectionB } from '../context/SectionBProvider';
import BehaviorChips from '../components/chips/BehaviorChips';
import { chipWords } from '../utils/behaviorChipWords';
import { useEffect } from 'react';

import { otherAnimalsNearby } from '../utils/assessments';
import { name as speciesName } from '../utils/species';
import MultiSelectChipsFilter from '../components/form/control/MultiSelectChipsFilter';



import { IconButton, Chip, Popover } from '@mui/material';
import UndoIcon from '@mui/icons-material/Undo';
import { sectionBBehaviors } from '../utils/sectionBBehaviors';
import { countSectionBBehavior } from '../utils/sections';


/*
behaviorKey="wallowing"
title="Wallowing"
count={sectionb.wallowing}
onSubmit={handleAdd}
animals={animals}
description={false}
location={false}
associatedAnimals={false}

behaviorKey="feeding"
title="Feeding"
count={sectionb.feeding}
onSubmit={handleAdd}
animals={animals}
description={false}
location={false}
associatedAnimals={false}
*/

export const behaviorsSource = sectionBBehaviors;





const CustomForm = ({children,onSubmit,...props}) => {
    const {handleSubmit,control,setValue, reset, formState: {defaultValues}} = useFormContext();

    //const contextFunc = (onSubmit) ? handleSubmit(onSubmit) : null;
    const contextFunc = handleSubmit(async (inputData)=>{
        const shouldReset = await onSubmit(inputData);
        if (shouldReset !== false) {
            reset(defaultValues);
        }
    });

    useEffect(() => {
        if(props.cb){
            props.cb(setValue,control)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[props])

    return (
        <form onSubmit={contextFunc} noValidate {...props}>
            {React.Children.map(children, child =>
                React.cloneElement(child, { control: control })
            )}
        </form>
    )
}


const BehaviorAccordion = ({
    behaviorKey,
    title,
    count = 0,
    onSubmit,
    animals,
    animalSpecies = '',
    description,
    location,
    associatedAnimals,
    showtags = false,
    behaviorTags = [],
    descriptionProps ={},
    locationProps = {},
    associatedAnimalsProps = {},
    chips=false,
    chipKey='',
    otherAnimalList=[]
    }) => {
    var callbackFunc=()=>{}
    var control={}
    const tooltipKey = "section_b_" + behaviorKey;


    const [open,setOpen] = React.useState(false);

    const handleClose = () => {
        setOpen(false)
    }

    const hasTagOptions = showtags && behaviorTags.length > 0;

    const handleClick = async () => {
        // if we have a configuration that requires additional data, then we show the drawer,otherwise count the click
        if (description || location || associatedAnimals || hasTagOptions) {
            setOpen(true)
        } else {
            const data = {behavior: behaviorKey, description: '', location: '', associated_animals: [], tags: []};
            await onSubmit(data);
        }
    }


    const hasDefinedValue = (value) => {
        if (Array.isArray(value)) return value.length > 0;
        if (typeof value === 'string') return value.trim().length > 0;
        return value !== undefined && value !== null;
    };

    const localOnSubmit = async (data) => {
        const renderedFields = [];
        if (hasTagOptions) renderedFields.push('tags');
        if (associatedAnimals) renderedFields.push('associated_animals');
        if (description) renderedFields.push('description');
        if (location) renderedFields.push('location');

        const hasAnyValue = renderedFields.some((fieldName) => hasDefinedValue(data[fieldName]));

        console.log("isDirty / hasAnyValue",  methods.formState.isDirty, hasAnyValue);

        if (!methods.formState.isDirty && !hasAnyValue) {
            methods.setError('root', {
                type: 'validate',
                message: 'Add at least one value before adding this behavior.',
            });
            return false;
        }

        methods.clearErrors('root');
        onSubmit(data);
        setOpen(false);
        return true;
    }

    const defaultValues = {behavior: behaviorKey, description: '',location: '', associated_animals: [], tags: []};
    const formProps = { defaultValues };
	const methods = useForm(formProps);
            //<FormProvider onSubmit={localOnSubmit} defaultValues={{behavior: behaviorKey, description: '',location: '', associated_animals: []}} ></FormProvider>

    const selectedTags = methods.watch('tags') || [];
    const toggleTag = (tagLabel) => {
        const nextTags = selectedTags.includes(tagLabel)
            ? selectedTags.filter((tag) => tag !== tagLabel)
            : [...selectedTags, tagLabel];
        methods.setValue('tags', nextTags, {
            shouldDirty: true,
            shouldTouch: true,
        });
    };

    const longPressTimer = React.useRef(null);
    const longPressTriggered = React.useRef(false);
    const [popoverAnchor, setPopoverAnchor] = React.useState(null);
    const [popoverText, setPopoverText] = React.useState('');

    const handlePressStart = (event, description) => {
        if (!description) return;
        longPressTriggered.current = false;
        const target = event.currentTarget;
        longPressTimer.current = setTimeout(() => {
            longPressTriggered.current = true;
            setPopoverAnchor(target);
            setPopoverText(description);
        }, 500);
    };

    const handlePressEnd = () => {
        clearTimeout(longPressTimer.current);
    };

    const handlePopoverClose = () => {
        setPopoverAnchor(null);
        setPopoverText('');
    };

    return (

    <Box>
        <Row>
            <EwpButton onClick={handleClick}>{title} ({count})</EwpButton>
            <CustomTooltip keyString={tooltipKey} >
                <HelpIcon sx={{marginLeft: 1}}/>
            </CustomTooltip>
        </Row>

        <FullScreenDrawer open={open} onClose={handleClose} height="90vh" title={title}>
            <FormProvider {...methods}>
            <CustomForm cb={(cb,ctrl)=>{callbackFunc=cb;control=ctrl}} onSubmit={localOnSubmit}>
                <Grid container spacing={2}>
                    <Grid xs={12} sm={12}>
                        <Typography variant="subtitle2">Select all that apply</Typography>
                    </Grid>
                    {hasTagOptions &&
                    <Grid xs={12} sm={12}>
                        <Typography variant="subtitle2">Specific Behaviors</Typography>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
                            {behaviorTags.map((tag) => {
                                const label = tag?.label || tag;
                                const tagDescription = tag?.description || '';
                                const selected = selectedTags.includes(label);
                                return (
                                    <Chip
                                        key={label}
                                        label={label}
                                        color={selected ? 'primary' : 'default'}
                                        variant={selected ? 'filled' : 'outlined'}
                                        onClick={() => {
                                            if (longPressTriggered.current) return;
                                            toggleTag(label);
                                        }}
                                        onTouchStart={(e) => handlePressStart(e, tagDescription)}
                                        onTouchEnd={handlePressEnd}
                                        onMouseDown={(e) => handlePressStart(e, tagDescription)}
                                        onMouseUp={handlePressEnd}
                                        onMouseLeave={handlePressEnd}
                                        sx={tagDescription ? { textDecoration: 'underline dotted', textUnderlineOffset: '3px' } : {}}
                                    />
                                );
                            })}
                        </Box>
                        <Popover
                            open={Boolean(popoverAnchor)}
                            anchorEl={popoverAnchor}
                            onClose={handlePopoverClose}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                            slotProps={{ paper: { sx: { p: 1.5, maxWidth: 280 } } }}
                        >
                            <Typography variant="body2">{popoverText}</Typography>
                        </Popover>
                    </Grid>
                    }

                    {associatedAnimals &&
                    <Grid xs={12} sm={12}>
                        <FormMultiSelectChipsFilter
                            enableSelectAll
                            name="associated_animals"
                            label="Associated Animals"
                            list={otherAnimalList}
                            enableTextFilter={true}
                            enableSelectFilter={true}
                            selectFilterList={(animals || []).reduce((acc, cur) => { if (!acc.includes(cur.species)) acc.push(cur.species); return acc; }, []).map((cur) => ({ value: cur, label: speciesName(cur) }))}
                            defaultSelectFilter={animalSpecies}
                            {...associatedAnimalsProps}
                        />
                    </Grid>
                    }
                    {description &&
                    <Grid xs={12} sm={12}>
                        <FormTextField  multiline shrinkLabel
                        rows={4} name="description" label="Description (if needed)" {...descriptionProps} />
                    </Grid>
                    }
                    {
                        chips &&
                        <>
                        <BehaviorChips words={chipKey ? chipWords[chipKey] : chipWords[behaviorKey]} onChipPress={(chipText)=>{
                            const existingDescription = control._formValues.description;
                            const updatedDescription = existingDescription ? `${existingDescription}\n${chipText}` : chipText;
                            callbackFunc('description', updatedDescription);
                        }}/>
                        </>
                    }
                    {location &&
                    <Grid xs={12} sm={12}>
                        <FormTextField name="location" label="Location" required {...locationProps} />
                    </Grid>
                    }
                    <Grid xs={4} sm={4}>
                        <FormButton>Add</FormButton>
                    </Grid>
                    {methods.formState.errors.root?.message &&
                    <Grid xs={12} sm={12}>
                        <Typography color="error" variant="body2">
                            {methods.formState.errors.root.message}
                        </Typography>
                    </Grid>
                    }
                </Grid>
            </CustomForm>
            </FormProvider>
        </FullScreenDrawer>


    </Box>

    );
}

// if you need to load data, you can use this template, note that the return value needs to be an object with named records in it.
export async function loader({params}) {
    return {
        assessment: await getAssessment(params.assessmentId),
        animals: await listAnimals(),
        sectionbRecord: await getSectionB(params.sectionBId),
        behaviorTagSets: await listBehaviorTagSets()
    };
}

export default function AssessmentSectionBFormPage({title = "EWP",...props}) {
    const {setSuccess, setError, setMessage} = useMessage();
    const {hideNavigation,showNavigation} = useLayout();
    const navigate = useNavigate();
    const {confirm} = useConfirmationDialog();
    const {isOnline} = useConnectivity();

    const {isRunning, startTimer, endTimer} = useTimer();

    const {inProgressObservations, current, isClipboardMode, setObservation, removeObservation, stopClipboardMode} = useSectionB();

    // used to read the loader data that is returned from the function above
    const params = useParams();
    console.log("Params: ", params);


    //const {assessment, animals, sectionbRecord} = data || {};
    const {assessment, animals, sectionbRecord, behaviorTagSets} = useLoaderData();
    console.log("sectionB record from loader: ", sectionbRecord);
    const [sectionb,setSectionb] = React.useState(sectionbRecord);

    React.useEffect(()=>{
        if (isClipboardMode && current) navigate("/assessments/" + current.assessmentId + "/sectionb/" + current.id);

        if (isClipboardMode && current === undefined) {
            stopClipboardMode();
            resetTimer();
            navigate("/assessments/" + assessment.id);
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[current]);

    // handles a switch using the observation clipboard system
    React.useEffect(()=>{
        setSectionb(sectionbRecord);
    },[sectionbRecord]);

    React.useEffect(()=>{
        const saveChange = async () => {
            console.log("sectionb save local: ", sectionb);
            //await onChange();
            const saveResult = await saveSectionBLocal(sectionb);
            console.log(saveResult);
        };
        saveChange();
    },[sectionb]);

    console.log("assessment: ", assessment, "animals:", animals);

    //const animal = findModel(animals || [],assessment?.animal_id);
    const animal = findModel(animals,assessment.animal_id);
    const animalSpecies = animal?.species || '';
    const behaviorTagMap = React.useMemo(() => {
        const map = {};
        (behaviorTagSets || [])
            .filter((tagSet) => tagSet.species === animalSpecies)
            .forEach((tagSet) => {
                map[tagSet.behavior_key] = Array.isArray(tagSet.tags) ? tagSet.tags : [];
            });
        return map;
    }, [behaviorTagSets, animalSpecies]);

    const [working,setWorking] = React.useState(false);

    // if you're going to do a form submission, this is your starting point for the submit behavior
    const onSubmit = async () => {
        try {
            setWorking(true);
            if (inProgressObservations.length <= 1) showNavigation();
            const data = {...sectionb, submitted_on: today()};
            if(data['other_animals_nearby'].includes('None')){
                data['other_animals_nearby'] = [];
            }
            console.log("onSubmit section b data", data);
            //console.log(sectionb);

            const saveResult = await saveSectionB(data,isOnline);
            console.log("sectionb save: ", saveResult);

            setSuccess("Section Data Saved");

            if (inProgressObservations.length > 0) removeObservation(current);

            /*
            if (inProgressObservations.length > 0 && current) {
                navigate("/assessments/" + current.assessmentId + "/sectionb/" + current.id);
            } else {
                navigate("/assessments/" + assessment.id);
            }
            */

            if (isClipboardMode === false && current === undefined) {
                resetTimer();
                navigate("/assessments/" + assessment.id);
            }


        } catch (error) {
            console.error(error);
            setError(error);
        } finally {
            setWorking(false);
        }
    }


    const [showBackArrow,setShowBackArrow] = React.useState(true);
    const [showForm,setShowForm] = React.useState(false);


    const [behaviorStack,setBehaviorStack] = React.useState(sectionb.behaviors)
    React.useEffect(()=>{
        console.log("behaviorStack", behaviorStack);
    },[behaviorStack])



    const timerSeconds = assessment?.section_b_timer_seconds || 600;

    // timer state and handler functions
    //const [runTimer,setRunTimer] = React.useState(false);
    const toggleTimer = async () => {
        if (!isRunning) {
            // starts the timer
            console.log("starting timer");
            //setRunTimer(true);
            startTimer(timerSeconds)
            hideNavigation();
            setShowBackArrow(false);
            // show the main form
            setShowForm(true);
            // set record.observed_on to the curren timestamp locally
            setSectionb({...sectionb, observed_on: today()});


        } else {
            // prompt to confirm
            confirm({
                title: "Reset Observation?",
                message: "Confirming will cause the timer to stop and reset, but this also resets the observation data for this observation",
                onSubmit: async () => {
                    // reset the record
                    const temp = resetSectionBRecord(sectionb);
                    setSectionb({...temp});

                    setBehaviorStack([]);

                    // hides the form
                    setShowForm(false);

                    // reset the timer
                    resetTimer();
                }
            })
        }
    }

    const resetTimer = () => {
        showNavigation();
        setShowBackArrow(true);
        endTimer();
        //setRunTimer(false);
    }

    const timerFinished = () => {
        setMessage("Timer Finished");
        resetTimer();
    }

    const handleUndo = () => {
        console.log("undo");

        const undoBehavior = {...behaviorStack[behaviorStack.length - 1]};
        setBehaviorStack(prevItems => prevItems.slice(0, -1));

        const tempBehaviors = sectionb.behaviors.filter(item => item.id !== undoBehavior.id);
        //const counts = countBehaviors(tempBehaviors);

        const obj = {}
        obj.behaviors = tempBehaviors;
        setSectionb({...sectionb, ...obj});
    }

    const handleAdd = (inputData) => {
        console.log("Add: ",inputData);

        const newBehavior = {...newSectionBBehavior(),...inputData};
        newBehavior.section_b_id = sectionb.id;
        newBehavior.observed_on = today();
        console.log("new behavior: ", newBehavior);

        setBehaviorStack([...behaviorStack,newBehavior]);


        const newBehaviors = [...sectionb['behaviors'],newBehavior];
        //const counts = countBehaviors(newBehaviors);

        const obj = {};
        obj.behaviors = newBehaviors
        setSectionb({...sectionb, ...obj});
        // record change/save here
    }

    const handleChange = (e) => {
        console.log(e);
        const field = e.target.name;
        const obj = {}
        obj[field] = e.target.value;
        setSectionb({...sectionb,...obj});
    }

    const handleAnimalChange = (values,field) => {
        console.log("values: ", values);
        const obj = {}
        obj[field] = values;
        setSectionb({...sectionb,...obj});
    }

    return (
        <Container component="main" maxWidth="sm">
            {sectionb && <>
            {showBackArrow && <GoBack onClick={()=>navigate(`/assessments/${assessment.id}`)} />}
            <Header label={title} />

            {isClipboardMode && inProgressObservations.length > 1 &&
            <Grid container spacing={2}>
                {inProgressObservations.map((cur,index)=>(
                    <Grid key={cur.id} xs={12} sm={6}>
                        <EwpButton onClick={()=>{
                            setObservation(index);
                        }}>{cur?.title}</EwpButton>
                    </Grid>
                ))}
            </Grid>
            }

            <Grid container spacing={2}>
                <Grid xs={6} sm={6}>
                    <Typography>{assessment?.assessment_title || animal.name}</Typography>
                    <Typography>{sectionb.observation_range}</Typography>
                    <Typography>Behavior Count: {sectionb?.behaviors?.length || 0}</Typography>
                </Grid>
                <Grid xs={6} sm={6}>
                    <EwpButton onClick={toggleTimer}>
                        {(isRunning) ? <Timer onCompletion={timerFinished} /> : <TimerIcon />}
                    </EwpButton>
                </Grid>
                <Grid xs={6} sm={6}>
                </Grid>
            </Grid>

            <Grid container spacing={2} >
                <Grid xs={12} sm={6}>
                    <ComponentTextField name="current_weather_conditions" label="Current Weather Conditions" value={sectionb.current_weather_conditions || ''} onChange={handleChange}/>
                </Grid>

                <Grid xs={12} sm={6}>
                    <MultiSelectChipsFilter
                        name="other_animals_nearby"
                        label="Other Animals Nearby"
                        enableSelectNone
                        enableSelectAll
                        list={otherAnimalsNearby(animals, animal)}
                        value={sectionb.other_animals_nearby || []}
                        onChange={(value)=>handleAnimalChange(value,"other_animals_nearby")}
                        enableTextFilter={true}
                        enableSelectFilter={true}
                        selectFilterList={(animals || []).reduce((acc, cur) => { if (!acc.includes(cur.species)) acc.push(cur.species); return acc; }, []).map((cur) => ({ value: cur, label: speciesName(cur) }))}
                        defaultSelectFilter={animalSpecies}
                    />
                </Grid>



                {showForm &&
                <>

                <Grid xs={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Box>
                        <IconButton onClick={handleUndo} disabled={(behaviorStack.length === 0)} variant="contained">
                            <UndoIcon /> Undo
                        </IconButton>
                    </Box>
                </Grid>

                {behaviorsSource.map((cur,index)=>{
                    const localCount = countSectionBBehavior(sectionb.behaviors,cur.behaviorKey)
                    console.log("localCount", localCount);
                    return (
                        <Grid xs={12} sm={12} key={cur.behaviorKey}>
                            <BehaviorAccordion
                                behaviorKey={cur.behaviorKey}
                                title={cur.title}
                                count={localCount}
                                onSubmit={handleAdd}
                                animals={animals}
                                animalSpecies={animalSpecies}
                                description={cur.hasDescription}
                                location={cur.hasLocation}
                                associatedAnimals={cur.hasAssociatedAnimals}
                                showtags={cur.showtags}
                                behaviorTags={behaviorTagMap[cur.behaviorKey] || []}
                                otherAnimalList={otherAnimalsNearby(animals,animal)}
                            />
                        </Grid>
                    );
                })}

                <Grid xs={12} sm={12}>
                    <ComponentTextField name="comments" label="Additional Comments" value={sectionb.comments || ''} onChange={handleChange} />
                </Grid>



                <Grid xs={12}>
                    <EwpButton onClick={onSubmit} working={working}>Submit</EwpButton>
                </Grid>
                </>
                }

            </Grid>

            </>}
        </Container>
    );
}
